export default __webpack_public_path__ + "static/media/one.f055d6af.jpeg";